export * from './carousel-container/carousel-container.component';
export { CarouselContainerComponent as CarouselContainerModule } from './carousel-container/carousel-container.component';
export * from './carousel-slide/carousel-slide.component';
export { CarouselSlideComponent as CarouselSlideModule } from './carousel-slide/carousel-slide.component';
export * from './carousel-slides-wrapper/carousel-slides-wrapper.component';
export { CarouselSlidesWrapperComponent as CarouselSlidesWrapperModule } from './carousel-slides-wrapper/carousel-slides-wrapper.component';
